import http from "./http";
const blobUtil = {
    /**
     * excel导出
     * @param {*} config 参数
     * @param {*} sort 排序
     */
    excelExport(config, sort) {
        http.post(
            "./api/main/excelexport/exportSimple",
            {
                config: config,
                sort: sort,
                pageNo: 1,
                pageSize: -1,
                funid: config.funid,
                menuid: config.menuid,
                defaulttablename: config.defaulttablename
            },
            {
                responseType: "blob",
                showSuccess: false
            }
        ).then(({ success, data, errMsg }) => {
            if (success) {
                let aLink = document.createElement("a");
                let blob = new Blob([data], { type: "application/vnd.ms-excel" });
                aLink.href = URL.createObjectURL(blob);
                aLink.setAttribute("download", config.file_name + ".xlsx"); // 设置下载文件名称
                aLink.click(); //执行下载
                document.body.appendChild(aLink);
                URL.revokeObjectURL(aLink.href); //释放url
                document.body.removeChild(aLink); //释放标签
                // this.$refs.loadElement.appendChild(aLink);
            }
        });
    },
    /**
     * 打印
     * @param {*} id 单据ID
     * @param {*} rptid 打印模板ID
     */
    ireportPrint(id, rptid) {
        http.post(
            "./api/main/report/generateReport",
            {
                ID: id,
                rptid: rptid
            },
            {
                responseType: "blob",
                showSuccess: false
            }
        ).then(({ success, data, errMsg }) => {
            if (success) {
                let binaryData = [];
                binaryData.push(data);
                let url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }));
                window.open(url);
                // window.open("/static/pdf/web/viewer.html?file=" + encodeURIComponent(url));
            } else {
                this.$FG_message.error("P0002");
            }
        });
    }
};
export default blobUtil;
